/** 迁移自 kbWelfareCenter/src/kb_welfare/rootStore.js */

import React from 'react';
import { detector } from './lib/util/Detect.js';
import { SignInCoinDialog, ActionFalseDialog, OpenRedpackDialog, SignInVipDialog } from './components';
import { setDailyTask, setSignTask, setIsNewUser, setHasInviteCard, setMyIntegral, mapAppMainAccount, setIsLogin, setCredit, setPreProcess, setDialogs, setShowTaotieSwing, setShowTaotie, setShowPropertyTransAnim, setWithdrawMiniNum } from './actions';
import { post, $http, loginWithInfo, showLoginPanel } from './lib/kbApp/kbJsBridgePromise';
import { getAppMainAccount } from './lib/services/kbAppService';
import { getHost, ACCOUNT, excitedVideoAdApiJsUrl, nfaMotivationJsUrl, aegisOpts, hostv2 } from './const';
import signInError from './const/signInError';
import { query } from './lib/util/common';
import { loadScript } from './lib/util/utils';
import store from './store';
import { showTip } from './lib/util/domUtil.js';
import sendBoss from './lib/base/sendBoss';
import Aegis from '@tencent/aegis-web-sdk';

export function getWelfareCenterParams() {
  const { kbApp } = store.getState();
  const { omgid = '', devid = '', imsi = '', guid = '', qua = '' } = kbApp;
  const { userId, token = '', skey = '', qbid = '', platform = '', appid = '', type = 1 } = kbApp.userInfo || {};

  const params = {
    applicationId: detector.app.kuaibao ? 1 : 0, // 1:快报, 0:qb
    welfareVersion: 2, // 区分福利中心新老版本
    userId,
    qbid: detector.app.kuaibao ? userId : qbid,  // 快报取userId，qb取qbid
    uin: userId,
    type,
    guid: detector.app.kuaibao ? omgid : guid,  // 快报取omgid，qb取guid
    token,
    skey,
    qua,
    platform,
    appid,
  };

  if (detector.app.kuaibao) {
    params.devType = detector.os.android ? 0 : (detector.os.iphone ? 1 : 0); // devType: 0:android;1:ios
    params.devId = detector.os.android ? (`${devid}_${imsi || ''}`) : (detector.os.iphone ? devid : ''); // android：devid加下划线
  }

  return params;
}

// 获取签到任务
export const getSignTaskAction = () => {
  const param = Object.assign(getWelfareCenterParams(), {
    signType: 2,
  });

  return post(`${getHost()}/newtickets/api/getSignTask`, param).then((res) => {
    if (res.code === 0) {
      const signTaskData = res.data.signTask || [];
      signTaskData.hasSigned = res.data.hasSigned;

      store.dispatch(setSignTask(signTaskData));
    }
  });
};

// 签到
let signInLock = false;
export const signInAction = (type) => {
  if (signInLock) {
    return;
  }

  let signType = 'defaultsign';
  if (type === 'vip') {
    signType = 'vipsign';
  } else if (type === 'cash') {
    signType = 'cashsign';
  }

  const { dialogs } = store.getState();
  const param = Object.assign(getWelfareCenterParams(), {
    refer: query('refer') || '',
  });
  signInLock = true;
  // sendBoss('element_click', {
  //   element_type: `${signType}`,
  //   element_name: `${signType}_popup_login_confirm`,
  // });
  post(`${getHost()}/newtickets/api/signIn`, param).then((res) => {
    signInLock = false;

    dialogs.pop();  // 清空弹窗（如果有的话）
    if (res.code === 0) {
      const { data } = res;
      const { signTask } = data;

      const {
        stepWelfare = [],
        completed = 0,
        isContinueTask,
        continueTaskDays = 0,
      } = signTask;
      const taskDays = isContinueTask ? continueTaskDays : completed;

      signTask.hasSigned = true;
      store.dispatch(setSignTask(signTask));

      const welfare = stepWelfare[taskDays > 0 ? taskDays - 1 : 0] || {};
      const welfareInfo = welfare.welfareInfo || {};
      const len = dialogs.length;

      if (type === 'vip') {   // vip卡券奖励
        store.dispatch(setDialogs(dialogs.concat([
          <SignInVipDialog
            key={len}
            welfareInfo={welfareInfo}>
          </SignInVipDialog>,
        ])));
      } else if (type === 'cash') {  // 现金奖励
        const value = welfareInfo.value / 100 || 0;
        store.dispatch(setDialogs(dialogs.concat([
          <OpenRedpackDialog key={len} num={value.toFixed(2)} desc="签到成功，今日现金已领取" from="signin"></OpenRedpackDialog>,
        ])));
      } else {
        store.dispatch(setDialogs(dialogs.concat([
          <SignInCoinDialog
            key={len}
            welfare={welfare}
            value={welfareInfo.value || 0}
            welfareType={welfareInfo.welfareType}>
          </SignInCoinDialog>,
        ])));
      }
    }
  })
    .catch((res) => {
      const { code } = res;
      const msg = signInError[code] || '请求异常，请稍后再试';
      const len = dialogs.length;
      store.dispatch(setDialogs(dialogs.concat([
        <ActionFalseDialog key={len} title="很抱歉，签到失败" subTitle={msg}></ActionFalseDialog>,
      ])));
    });
};

// 初始化广告js
export const initAd = async (taskId) => {
  // 加载广告js
  if (detector.app.kuaibao) {
    loadScript(excitedVideoAdApiJsUrl).then(() => {
      window.QBExcitedVideoAdApi && window.QBExcitedVideoAdApi.onStateChange((state, res, adRes = {}, amsData = {}) => {
        if (state === 'onADClose') {
          // 刷新资产和任务列表
          getMyIntegralAction();
          getTaskDataAction(false);
        } else if (state === 'onError') {
          showTip('视频加载失败，请重试', 3000, { style: 'width: 2rem;' });
          // 上报atta
          sendBoss('loadAdFail', {
            extra_info: {
              amsData,
            },
          });
        }
      });
      // 加载广告，进度页面时预载
      const env = process.env.isTest || process.env.NODE_ENV === 'development' ? 'test' : 'production';
      window.QBExcitedVideoAdApi && window.QBExcitedVideoAdApi.loadAD(taskId, env);
    });
  } else if (detector.app.qb) {
    await loadScript(nfaMotivationJsUrl);
  }
};

/**
 * 获取任务列表
 * @param {boolean} loadAd 是否初始化广告
 */
export const getTaskDataAction = (loadAd = true, from = '') => {
  if (from === 'sendTask') {
    sendBoss('sendTaskRedPackResponceAfter', {
      extra_info: { time: new Date().getTime() },
    });
  }
  const param = Object.assign(getWelfareCenterParams(), {
    refer: query('refer') || '',
  });

  return post(`${getHost()}/newtickets/api/getTasks`, param).then((res) => {
    if (res.code === 0) {
      store.dispatch(setIsNewUser(res.data.isNewUser || false));
      store.dispatch(setWithdrawMiniNum(res.data.withdrawMinimun));

      const dailyTasks = (res.data && res.data.dailyTasks) || [];
      const tasks = [];
      dailyTasks.forEach((task) => {
        // 临时加下 为了屏蔽1002 qb广告任务在正式环境不展示
        if ([0, 1, 2].includes(task.taskBelong) && ![2300, 2301, 2900].includes(task.businessId)) {   // 签到和邀请拎出来，不在日常任务里
          tasks.push(task);
        }

        if (task.businessId === 2900) {  // 存在邀请模块
          store.dispatch(setHasInviteCard(true));
        }
      });

      // 判断是否有广告任务 是就加载广告js
      if (loadAd) {
        const adTasks = tasks.filter(task => task.businessId === 3100 || task.businessId === 1002);
        adTasks.length > 0 && initAd(adTasks[0].taskId);
      }

      const formatTasks = tasks.filter((item) => {
        if (item.businessId === 301) {
          return item.extraInfo && Number(item.extraInfo.taskType) !== 1;
        }
        return true;
      });

      store.dispatch(setDailyTask(formatTasks));
    }
  });
};

// 获取账号现金金币信息
export const getMyIntegralAction = () => $http.get(`${hostv2}/ugwelfare/api/getMyIntegral`, {
  params: Object.assign(getWelfareCenterParams(), {
    scene: 'kb_welfare',
  }),
}).then((res) => {
  if (res.code === 0) {
    const asset = res.data || {};
    if (asset.rate < 20000) asset.rate = 20000;
    store.dispatch(setMyIntegral(asset));
    // 在快报里自动把金币转成现金
    // detector.app.kuaibao && autoExchange(res.data);
  }
})
  .catch((res) => {
    if (res.code) {
      switch (res.code) {
        case 4003:
          showTip('登录态过期，请重新登录', 3000, { style: 'width: 2rem;' });
          break;
        default:
          break;
      }
    }
  });

// 统一登录逻辑
export const loginAction = (loginInfo) => {
  if (detector.app.kuaibao) {
    return loginWithInfo(loginInfo).then(() => {
      // 获取主登录账号及账号信息
      getAppMainAccount().then((res) => {
        store.dispatch(mapAppMainAccount(res));
      })
        .then(() => {
          getSignTaskAction().then(() => {
            store.dispatch(setIsLogin(true)); // 设置全局登录态
          });
          getMyIntegralAction();
          getTaskDataAction();
          getUserCreditAction();
          initAegis();
        });
    });
  }
  showLoginPanel();
};

export const getUserCreditAction = () => {
  const param = getWelfareCenterParams();

  return post(`${getHost()}/newtickets/api/getCredit`, param).then((res) => {
    if (res.code === 0) {
      store.dispatch(setCredit(res.data.credit || 0));
    }
  })
    .then(() => {
      addTransAccountDialog();
    });
};

export function doPreProcess(cbk, list) {
  const preProcessList = list || store.getState().preProcess;
  // 暂时不做异步操作
  preProcessList.forEach((process) => {
    process();
  });

  if (preProcessList.length === 0 && cbk) return cbk;
  return () => {};
}

export async function getSmallPrice() {
  try {
    const res = await $http.get(`${hostv2}/ugwelfare/api/smallPrice`, {
      params: getWelfareCenterParams(),
    });
    if (res.code === 0 && res.data) return res.data.smallPrice;
  } catch (error) {
    console.error(error);
    return 30 * 60;
  }
}

// push 切换账号指引弹窗
export function addTransAccountDialog() {
  const { mainAccount } = store.getState().kbApp;
  const { credit } = store.getState();
  let title;
  let subTitle;

  if (mainAccount !== 'other' && ![ACCOUNT.STATUS.NOT_MATCH_DEVICE, ACCOUNT.STATUS.TINAYU_BLACK].includes(credit)) {
    store.dispatch(setPreProcess([]));
    return;
  }
  if (mainAccount === 'other') {
    // 手机登录
    title = '很抱歉，请切换帐号';
    subTitle = '活动仅限QQ或微信登录用户参加';
  } else if (ACCOUNT.STATUS.NOT_MATCH_DEVICE === credit) {
    // 未绑定
    title = '很抱歉，设备已经绑定别的账号';
    subTitle = '需要登录绑定账号才可以参与活动';
  } else if (ACCOUNT.STATUS.TINAYU_BLACK === credit) {
    // 天域高风险
    title = '很抱歉，账号异常';
    subTitle = '可切换其他账号尝试参与活动';
  }

  const { dialogs } = store.getState();
  const len = dialogs.length;
  const { preProcess } = store.getState();
  const process = () => {
    store.dispatch(setDialogs(dialogs.concat([
        <ActionFalseDialog key={len} title={title} subTitle={subTitle} from="transAccount"></ActionFalseDialog>,
    ])));
  };

  if ([ACCOUNT.STATUS.NOT_MATCH_DEVICE, ACCOUNT.STATUS.TINAYU_BLACK].includes(credit)) {
    // 这种情况是进入页面就要弹窗
    doPreProcess(null, [process]);
  }
  store.dispatch(setPreProcess(preProcess.concat(process)));
}

export function setWelfareAnimation() {
  const { isShowTaotieSwing } = store.getState();
  if (isShowTaotieSwing) return;
  store.dispatch(setShowTaotie(true));
  setTimeout(() => {
    store.dispatch(setShowTaotieSwing(true));
    store.dispatch(setShowTaotie(false));
  }, 3700);
}

// 前端增量增加金币或现金
export function setProperty(params) {
  console.log(params, 'params');
  const { value, welfareType } = params;
  const { myIntegral } = store.getState();
  let updateType = '';

  if (welfareType === 0 || welfareType === 4) {
    // 现金
    updateType = 'cash';
  } else if (welfareType === 3 || welfareType === 5) {
    // 金币
    updateType = 'coin';
  }

  // 不是金币或者现金 不用更新资产做动画
  if (updateType !== 'cash' && updateType !== 'coin') return;

  const propertyTransAnim = {};

  const amountDiff = updateType === 'cash' ? value / 100 : 0;
  const integralDiff = updateType === 'coin' ? value : 0;

  switch (updateType) {
    case 'coin':
      propertyTransAnim.integralDiff = integralDiff;
      break;
    case 'cash':
      propertyTransAnim.amountDiff = amountDiff;
      break;
    default:
      break;
  }

  const { integral = 0, amount = 0 } = myIntegral || {};
  const property = {
    ...myIntegral,
    integral: integral + integralDiff,
    amount: amount + amountDiff,
  };

  store.dispatch(setMyIntegral(property));
  store.dispatch(setShowPropertyTransAnim(propertyTransAnim));
}

// 初始化aegis
export function initAegis() {
  const { kbApp } = store.getState();
  const { qbid = '' } = kbApp.userInfo || {};
  const defaultOpts = detector.app.kuaibao ? aegisOpts.kb : aegisOpts.qb;

  const opts = {
    ...defaultOpts,
    uin: qbid,
    reportApiSpeed: true,
    reportAssetSpeed: true,
    offlineLog: true,
    spa: true,
  };

  const aegis = new Aegis(opts);
  window.aegisIns = aegis;
}


export async function getKbAsset(opts = {}) {
  const params = Object.assign(getWelfareCenterParams(), opts);
  return $http.post(`${hostv2}/ugwelfare/api/getKbAsset`, {
    data: params,
  });
}

export async function withdrawKb(opts = {}) {
  const params = Object.assign(getWelfareCenterParams(), opts);
  return $http.post(`${hostv2}/ugwelfare/api/kbOfflineWithdraw`, {
    data: params,
  });
}

export async function checkBlackAccount(opts = {}) {
  const params = Object.assign(getWelfareCenterParams(), opts);
  return $http.post(`${hostv2}/ugwelfare/api/userSCheck`, {
    data: params,
  });
}

// 兑换现金
let withdrawLock = false;
export async function autoExchange(myIntegral = {}) {
  if (withdrawLock) return;
  const { integral = 0, amount = 0 } = myIntegral;
  console.log(myIntegral, 'myIntegral');
  if (integral <= 0) return;
  withdrawLock = true;

  $http.get(`${hostv2}/ugwelfare/api/kbOfflineExchange`, {
    params: Object.assign(getWelfareCenterParams(), {
      scene: 'kb_v2',
    }),
  }).then((res) => {
    if (res.code === 0 && res.data) {
      const { exchangeIntegral = 0, getAmount = 0 } = res.data;
      console.log(res.data, 'res.data');
      store.dispatch(setMyIntegral({
        ...myIntegral,
        integral: integral - exchangeIntegral,
        amount: (getAmount + (amount * 100)) / 100,
      }));
    }
  })
    .finally(() => {
      withdrawLock = false;
    });
}

// https://qbact.sparta.html5.qq.com/welfareuser/api/delVeriyIdCard?qbid=154b8153002ed8c5
export async function idOffAction() {
  const param = getWelfareCenterParams();

  return $http.post(`${hostv2}/welfareuser/api/delVeriyIdCard`, {
    data: param,
  });
}

export async function getBindIdcard() {
  const param = getWelfareCenterParams();

  return $http.get(`${hostv2}/welfareuser/api/getBindIdcard`, {
    params: param,
  });
}
